import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../utils/LStrings';
import {
    map
} from 'lodash';
import {
    Panel
} from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor'
import TableUtils from '../../../../../utils/TableUtils';
import TablePlain from '../../../../../components/table-plain/TablePlain';
import StrongText from '../../../../../components/strong-text/StrongText';
import PermissionChecker from '../../../../../components/permission-checker/PermissionChecker';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class PanelDatosParticulares extends React.Component {

	onRequestInfo = (infoKey, infoTitle) => {
		this.props.onRequestInfo(lstrings.datosparticulares_title, infoTitle);
	}

	render() {
		let titulo =
			<h2><i className="fa fa-user"></i> {lstrings.datosparticulares_title}</h2>;

		return (
			<ScrollableAnchor id={'panel-datosparticulares'}>
				<Panel collapsible defaultExpanded header={titulo}>
					<TablePlain title={'General'}
						columns={[
							'Nombre',
							'CUIT / CUIL',
							'Nro DNI',
							'Versión DNI',
							'Nacionalidad',
							'Año',
							'Fecha Nacimiento',
							'Fecha Defunción',
							'Edad',
							'Sexo'
						]}
						rows={[(<tr key={0}>
							<td>{TableUtils.stringFormat(this.props.info.apellidoNombre)}</td>
							<td>{TableUtils.stringFormat(this.props.info.cuil)}</td>
							<td>{TableUtils.stringFormat(this.props.info.dni)}</td>
							<td>{TableUtils.stringFormat(this.props.info.tipo)}</td>
							<td>{TableUtils.stringFormat(this.props.info.nacionalidad)}</td>
							<td>{TableUtils.stringFormat(this.props.info.anio)}</td>
							<td>{TableUtils.dateFormat(this.props.info.fechaNacimiento)}</td>
							<td><StrongText text={TableUtils.dateFormat(this.props.info.fechaDeceso)}/></td>
							<td>{TableUtils.stringFormat(this.props.info.edad)}</td>
							<td>{TableUtils.stringFormat(this.props.info.sexo)}</td>
						</tr>)]} />

					<PermissionChecker
						infoKey='domicilio'
						infoTitle='Domicilio Particular'
						data={this.props.info.domicilio}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}>
						{this.props.info.domicilio &&
							<TablePlain fixed={true}
							columns={['Ubicación', 'Código Postal', 'Localidad', 'Provincia']}
							showCount
							rows={map([0], (item, ix) =>
								<tr key={ix}>
									<td>{TableUtils.stringFormat(this.props.info.domicilio)}</td>
									<td>{TableUtils.stringFormat(this.props.info.cp)}</td>
									<td>{TableUtils.stringFormat(this.props.info.localidad)}</td>
									<td>{TableUtils.stringFormat(this.props.info.provincia)}</td>
								</tr>)}
							/>}
					</PermissionChecker>

					<PermissionChecker
						infoKey='domAlternativos'
						infoTitle='Otros domicilios'
						data={this.props.info.domAlternativos}
						onRequestInfo={this.onRequestInfo}
						hidePanels={this.props.hidePanels}>
						{this.props.info.domAlternativos &&
							<TablePlain fixed={true}
							columns={['Ubicación', 'Código Postal', 'Localidad', 'Provincia']}
							rows={map(this.props.info.domAlternativos.datos, (item, ix) =>
								<tr key={ix}>
									<td>{TableUtils.stringFormat(item.domicilioAlt)}</td>
									<td>{TableUtils.stringFormat(item.cpAlt)}</td>
									<td>{TableUtils.stringFormat(item.localidadAlt)}</td>
									<td>{TableUtils.stringFormat(item.provinciaAlt)}</td>
								</tr>)}
							/>}
					</PermissionChecker>
			</Panel>
		</ScrollableAnchor>
		);
	}
}

PanelDatosParticulares.propTypes = {
    info: PropTypes.object.isRequired,
    onRequestInfo: PropTypes.func,
    hidePanels: PropTypes.any
}

export default PanelDatosParticulares;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/components/PanelDatosParticulares.js